import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function trackingDataReducer(state = initialState.trackingData, action) {
    switch(action.type){
        case types.SET_TRACKING_DATA:
            //debugger;
            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
            return Object.assign({},action.trackingData);

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/trackingDataReducer.js
 **/